import React from "react";
import { useStateContext } from "../../../../../Context/StateContext";

export default function ClearAllorOnebyOne({ setfilter }) {
  const {
    state,
    setSortByTime,
    setSortLanguage,
    setSortPostType,
    setLocationType,
    setKeywords,
    setSpecialities,
    clearAllFields,
  } = useStateContext();
  const {
    sortByTime,
    sortlanguage,
    sortposttype,
    locationType,
    keywords,
    specialities,
  } = state;

  const removeFilter = (type, id) => {
    switch (type) {
      case "sortByTime":
        setSortByTime(sortByTime.filter((filter) => filter.id !== id));
        break;
      case "sortlanguage":
        setSortLanguage(sortlanguage.filter((filter) => filter.id !== id));
        break;
      case "sortposttype":
        setSortPostType(sortposttype.filter((filter) => filter.id !== id));
        break;
      case "locationType":
        setLocationType(locationType.filter((filter) => filter.id !== id));
        break;
      case "keywords":
        setKeywords(keywords.filter((filter) => filter.id !== id));
        break;
      case "specialities":
        setSpecialities(specialities.filter((filter) => filter.id !== id));
        break;
      default:
        break;
    }
  };

  const handleClearFilters = () => {
    if (setfilter) {
      setfilter(false);
    }
    clearAllFields();
  };
  return (
    <div>
      <div className="filter-head">
        <h4>Filters</h4>
        {/* <div className="filters">
                    {Array.isArray(sortByTime) && sortByTime?.map(filter => (
                        <div key={filter.id}>
                            {filter.title} <button onClick={() => removeFilter('sortByTime', filter.id)}>x</button>
                        </div>
                    ))}
                    {Array.isArray(sortlanguage) && sortlanguage?.map(filter => (
                        <div key={filter.id}>
                            {filter.title} <button onClick={() => removeFilter('sortlanguage', filter.id)}>x</button>
                        </div>
                    ))}
                    {Array.isArray(sortposttype) && sortposttype?.map(filter => (
                        <div key={filter.id}>
                            {filter.title} <button onClick={() => removeFilter('sortposttype', filter.id)}>x</button>
                        </div>
                    ))}
                    {Array.isArray(locationType) && locationType?.map(filter => (
                        <div key={filter.id}>
                            {filter.title} <button onClick={() => removeFilter('locationType', filter.id)}>x</button>
                        </div>
                    ))}
                    {Array.isArray(keywords) && keywords?.map(filter => (
                        <div key={filter.id}>
                            {filter.title} <button onClick={() => removeFilter('keywords', filter.id)}>x</button>
                        </div>
                    ))}
                    {Array.isArray(specialities) && specialities?.map(filter => (
                        <div key={filter.id}>
                            {filter.title} <button onClick={() => removeFilter('specialities', filter.id)}>x</button>
                        </div>
                    ))}
                </div> */}
        <a onClick={() => { handleClearFilters() }}>Clear filters</a>
      </div>
    </div>
  );
}
